var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/AssetNumberEnums';
let AssetNumberModule = class AssetNumberModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.loadPage = false;
        // api asset
        this.assetNumberList = [];
        this.page = 1;
        this.size = 10;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.desc = '';
        this.searchBy = '';
        this.paging = [];
        this.status = '';
        this.statusMessage = '';
        this.selectedAssetNumber = [];
        this.dropdownlistAssetNumber = [];
        this.dropdownlistSubAssetNumber = [];
        this.dropdownlistAssetDescription = [];
    }
    get getDropdownlistAssetNumber() {
        return this.dropdownlistAssetNumber;
    }
    get getDropdownlistSubAssetNumber() {
        return this.dropdownlistSubAssetNumber;
    }
    get getDropdownlistAssetDescription() {
        return this.dropdownlistAssetDescription;
    }
    get getAssetNumberLists() {
        return this.assetNumberList;
    }
    get getAssetNumberStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getSelectedAssetNumber() {
        return this.selectedAssetNumber;
    }
    get getAssetNumberPaging() {
        return this.paging;
    }
    get getAssetNumberLoading() {
        return this.loading;
    }
    get getStatusAssetNumber() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getAssetNumberSize() {
        return this.size;
    }
    get getAssetNumberWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getAssetNumberDesc() {
        return this.desc;
    }
    get getAssetNumberSearchBy() {
        return this.searchBy;
    }
    [_a = Mutations.SET_SELECTED_ASSETNUMBER](payload) {
        this.selectedAssetNumber = payload;
    }
    [_b = Mutations.SET_ASSETNUMBER_LIST](payload) {
        this.assetNumberList = payload;
    }
    [_c = Mutations.SET_ASSETNUMBER_LOADING](payload) {
        this.loading = payload;
    }
    [_d = Mutations.SET_ASSETNUMBER_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_e = Mutations.SET_ASSETNUMBER_PAGE](payload) {
        this.paging = payload;
    }
    [_f = Mutations.SET_ASSETNUMBER_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_g = Mutations.SET_ASSETNUMBER_STATUS](payload) {
        this.status = payload.statusAssetNumber;
        this.statusMessage = payload.statusMessageAssetNumber;
    }
    [_h = Mutations.SET_DROPDOWNLIST_ASSETNUMBER](payload) {
        this.dropdownlistAssetNumber = payload;
    }
    [_j = Mutations.SET_DROPDOWNLIST_SUB_ASSETNUMBER](payload) {
        this.dropdownlistSubAssetNumber = payload;
    }
    [_k = Mutations.SET_DROPDOWNLIST_ASSET_DESCRIPTION](payload) {
        this.dropdownlistAssetDescription = payload;
    }
    [_l = Mutations.SET_ASSETNUMBER_SIZE](payload) {
        this.size = payload;
    }
    [_m = Mutations.SET_ASSETNUMBER_HANDLE_SIZE](payload) {
        this.size = payload;
    }
    [_o = Mutations.SET_ASSET_NUMBER_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_p = Mutations.SET_ASSET_NUMBER_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_q = Mutations.SET_ASSET_NUMBER_DESC](payload) {
        this.desc = payload;
    }
    [_r = Mutations.SET_ASSET_NUMBER_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_s = Actions.GET_ASSETNUMBER_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSETNUMBER_LOADING, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/asset/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                Desc: '',
                assetNumber: this.selectedAssetNumber
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _z, _0;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_ASSETNUMBER_LIST, ((_z = res.data.result.content) === null || _z === void 0 ? void 0 : _z.data) || []);
                        this.context.commit(Mutations.SET_ASSETNUMBER_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_ASSETNUMBER_PAGE, ((_0 = res.data.result.content) === null || _0 === void 0 ? void 0 : _0.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        this.context.commit(Mutations.SET_ASSETNUMBER_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_ASSETNUMBER_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_t = Actions.GET_ASSETNUMBER_LIST_ALLDATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_NUMBER_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/asset/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '9999',
                Desc: this.desc.toString(),
                SearchBy: this.searchBy.toString()
            };
            const dataListAssetNumber = [...this.dropdownlistAssetNumber];
            const dataListSubAssetNumber = [...this.dropdownlistSubAssetNumber];
            const dataListAssetDescription = [...this.dropdownlistAssetDescription];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content.paging.totalPages === this.pageFilter) {
                            this.context.commit(Mutations.SET_ASSET_NUMBER_WAS_LOAD_QUICK_FILTER, false);
                        }
                        else {
                            this.context.commit(Mutations.SET_ASSET_NUMBER_WAS_LOAD_QUICK_FILTER, true);
                        }
                        res.data.result.content.data.map((data) => {
                            dataListAssetNumber.push({
                                value: data.assetNumber,
                                label: data.assetNumber
                            });
                        });
                        res.data.result.content.data.map((data) => {
                            dataListSubAssetNumber.push({
                                value: data.assetSubNumber,
                                label: data.assetSubNumber
                            });
                        });
                        res.data.result.content.data.map((data) => {
                            dataListAssetDescription.push({
                                value: data.assetDesc1,
                                label: data.assetDesc1
                            });
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctAssetNumber = Array.from(new Set(dataListAssetNumber.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataListAssetNumber.find((s) => s.label === label)
                                    .label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctSubAssetNumber = Array.from(new Set(dataListSubAssetNumber.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataListSubAssetNumber.find((s) => s.label === label)
                                    .label
                            };
                        });
                        // eslint-disable-next-line arrow-body-style
                        const distinctAssetDescription = Array.from(new Set(dataListAssetDescription.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataListAssetDescription.find((s) => s.label === label)
                                    .label
                            };
                        });
                        this.context.commit(Mutations.SET_DROPDOWNLIST_ASSETNUMBER, distinctAssetNumber);
                        this.context.commit(Mutations.SET_DROPDOWNLIST_SUB_ASSETNUMBER, distinctSubAssetNumber);
                        this.context.commit(Mutations.SET_DROPDOWNLIST_ASSET_DESCRIPTION, distinctAssetDescription);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_ASSET_NUMBER_WAS_LOAD_QUICK_FILTER, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_ASSET_NUMBER_WAS_LOAD_QUICK_FILTER, false);
                    reject(false);
                });
            });
        });
    }
    [_u = Actions.UPDATE_ASSETNUMBER_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSETNUMBER_SIZE, data);
            this.context.commit(Mutations.SET_ASSETNUMBER_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_ASSETNUMBER_LIST);
        });
    }
    [_v = Actions.UPDATE_ASSET_NUMBER_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_NUMBER_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_w = Actions.UPDATE_ASSET_NUMBER_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_NUMBER_SEARCH_BY, 'assetNumber');
            this.context.commit(Mutations.SET_ASSET_NUMBER_DESC, data);
            this.context.commit(Mutations.SET_ASSETNUMBER_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_DROPDOWNLIST_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_SUB_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_ASSET_DESCRIPTION, []);
            this.context.dispatch(Actions.GET_ASSETNUMBER_LIST_ALLDATA);
        });
    }
    [_x = Actions.UPDATE_SUB_ASSET_NUMBER_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_NUMBER_SEARCH_BY, 'assetSubNumber');
            this.context.commit(Mutations.SET_ASSET_NUMBER_DESC, data);
            this.context.commit(Mutations.SET_ASSETNUMBER_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_DROPDOWNLIST_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_SUB_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_ASSET_DESCRIPTION, []);
            this.context.dispatch(Actions.GET_ASSETNUMBER_LIST_ALLDATA);
        });
    }
    [_y = Actions.UPDATE_ASSET_DESCRIPTION_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_ASSET_NUMBER_SEARCH_BY, 'assetDesc1');
            this.context.commit(Mutations.SET_ASSET_NUMBER_DESC, data);
            this.context.commit(Mutations.SET_ASSETNUMBER_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_DROPDOWNLIST_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_SUB_ASSETNUMBER, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_ASSET_DESCRIPTION, []);
            this.context.dispatch(Actions.GET_ASSETNUMBER_LIST_ALLDATA);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssetNumberModule.prototype, _r, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetNumberModule.prototype, _s, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetNumberModule.prototype, _t, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetNumberModule.prototype, _u, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AssetNumberModule.prototype, _v, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetNumberModule.prototype, _w, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetNumberModule.prototype, _x, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AssetNumberModule.prototype, _y, null);
AssetNumberModule = __decorate([
    Module
], AssetNumberModule);
export default AssetNumberModule;
